import { Grid, Tab, Tabs } from "@mui/material";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { MDTypography } from "../../Component/Common/Components/MDTypography";
import { BEE123SalariesRole, EE123PeopleRole_Edit, EE123SalariesRole, PeopleEditRole } from "../../Component/Common/Constants/UserRoles";
import { useRouteMatch } from "../../Helpers/RouteMatcher";
import { userRolesState } from "../../State/user.Atom";
import { IndividualImport } from "./Imports/IndividualImport/IndividualImport";
import { IndividualSalariesImport } from "./Imports/IndividualSalaryImports/IndividualSalariesImport";

export const CentralDataManagementImportBase = () => {

    const routes = [
        "/import/manual/Database",
        "/import/manual/Salaries",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    const currentTabIndex = routes.findIndex(route => route === currentTab);

    const handleRedirect = () => {
        if (currentTabIndex === -1) {
            if (!userRoles.some(r => peopleRoleAccess.includes(r))) {
                return <Redirect to={routes[1]} />;
            }

            return <Redirect to={routes[0]} />;
        }

        return null;
    };

    const salaryRoleAccess = [
        EE123SalariesRole,
        BEE123SalariesRole
    ];

    const peopleRoleAccess = [
        PeopleEditRole,
        EE123PeopleRole_Edit
    ];

    const userRoles = useRecoilValue(userRolesState);

    return (
        <>
            <MDTypography variant="h4" style={{ paddingBottom: "20px" }}>Central Data Management - Import</MDTypography>
            <Grid container>
                <Grid item xs={12}>
                    <Tabs value={currentTab} aria-label="Tabs" centered>
                        {userRoles.some(r => peopleRoleAccess.includes(r)) &&
                            <Tab label="People" value={routes[0]} to={routes[0]} component={Link} />}
                        {userRoles.some(r => salaryRoleAccess.includes(r)) &&
                            <Tab label="Salaries" value={routes[1]} to={routes[1]} component={Link} />}
                    </Tabs>
                </Grid>
                <Grid item xs={12} mt={1}>
                    <Switch>
                        {handleRedirect()}
                        <Route path={routes[0]}>
                            <IndividualImport />
                        </Route>
                        <Route path={routes[1]}>
                            <IndividualSalariesImport />
                        </Route>
                    </Switch>
                </Grid>
            </Grid>
        </>);
}